import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English is bundled inline (default / fallback language for Baroom).
// Other locales are loaded on demand via dynamic import().
import translationEN from './locales/en.json';

const localeLoaders = {
  de: () => import('./locales/de.json'),
  fr: () => import('./locales/fr.json')
};

// Dynamically load a locale and register it with i18next
function loadLocale(lng) {
  const loader = localeLoaders[lng];
  if (!loader) return Promise.resolve(); // unknown or already-bundled (en)
  return loader().then((mod) => {
    i18n.addResourceBundle(lng, 'translation', mod.default || mod, true, true);
  });
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN }
    },
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },

    // Render immediately with EN, swap once the real locale is ready
    react: {
      useSuspense: false
    }
  });

// After init, if the detected language is not English, load it now.
const detected = i18n.language?.split('-')[0]; // handle "de-CH" → "de"
if (detected && detected !== 'en' && localeLoaders[detected]) {
  loadLocale(detected).then(() => {
    i18n.changeLanguage(detected);
  });
}

// Hook into future language changes so switching via LanguageSwitcher
// automatically loads the locale on demand.
i18n.on('languageChanged', (lng) => {
  const base = lng?.split('-')[0];
  if (base && base !== 'en' && localeLoaders[base] && !i18n.hasResourceBundle(base, 'translation')) {
    loadLocale(base);
  }
});

export default i18n;
